import type { HTMLAttributes } from 'react';

import { cn } from '@shared/lib/utils';

export type SearchFilterToolbarProps = HTMLAttributes<HTMLDivElement>;

export function SearchFilterToolbar({ children, className, ...props }: SearchFilterToolbarProps) {
  return (
    <div
      role="search"
      data-slot="search-filter-toolbar"
      className={cn('flex min-w-0 items-end gap-3', className)}
      {...props}
    >
      {children}
    </div>
  );
}
